import React from "react";
import Heading from "../ui/Heading";
import { Container } from "react-bootstrap";
import InstaIframe from "../../../InstaIframe";

const Insta = () => {
  return (
    <section className="insta-section">
        <div className="main_heading">
          <h2>Get a Tour of our Social Media</h2>
        </div>
        <InstaIframe />
    </section>
  );
};

export default Insta;
